export default {
  state: {
    storedPosition: 0,
  },
  getters: {
    getStoredPosition(state) {
      return state.storedPosition;
    },
  },
  mutations: {
    saveStoredPosition(state, payload) {
      state.storedPosition = payload;
    },
    resetStoredPosition(state) {
      state.storedPosition = 0;
    },
  },
  actions: {
    asyncChangeCounter({ commit }, payload) {
      setTimeout(() => {
        commit("changeCounter", payload.value);
      }, payload.time);
    },
  },
};
